import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ModuleLayout from '../../layout/ModuleLayout';
import { useTranslation } from 'react-i18next';
import {
  FaShoppingBasket,
  FaFileContract,
  FaTruckLoading,
  FaFileInvoice,
  FaUndoAlt,
  FaUserCheck,
  FaList,
  FaMoneyCheck,
  FaChartLine,
  FaUser,
  FaUserCircle,
  FaBook
} from 'react-icons/fa';

// Import components
import PurchasePage from '../Purchase/PurchasePage';
import BuyForm from '../Purchase/BuysForm';
import BuysReport from '../Purchase/BuysReport';
import ReceptionPage from '../Reception/ReceptionPage';
import SupplierInvoiceList from '../SupplierInvoice/SupplierInvoiceList';
import FournisseurRetourList from '../RetourFournisseur/FournisseurRetourList';
import SupplierList from '../Fournisseur/FournisseurList';
import FournisseurList from '../Fournisseur/FournisseurList';
import FournisseurForm from '../Fournisseur/FournisseurForm';
import InvoiceForm from '../SupplierInvoice/InvoiceForm';
import FournisseurRetourForm from '../RetourFournisseur/FournisseurRetourForm';
import ExpenseCategorieList from '../Expenses/ExpenseCategorieList';
import ExpenseForm from '../Expenses/ExpenseForm';
import ExpenseList from '../Expenses/ExpenseList';
import ReglementsFournisseurList from '../ReglementFournisseur/ReglementsFournisseurList';
import ReglementFournisseurForm from '../ReglementFournisseur/ReglementForm';
import FournisseurEcheance from '../ReglementFournisseur/FournisseurEcheance';
import AchatsStatistiques from '../Dashboard/AchatsStatistiques';
import MouvementSoldeFournisseur from '../MouvementSolde/MouvementSoldeFournisseur';
import MouvementSoldeCommercial from '../MouvementSolde/MouvementSoldeCommercial';
import EtatFournisseur from '../Fournisseur/EtatFournisseur';
import GrandLivreFournisseurPage from '../Fournisseur/GrandLivreFournisseurPage';

const PurchasesModule = () => {
  const { t } = useTranslation();

  const moduleConfig = {
    id: 'purchases',
    title: t('modules.purchases.title'),
    description: t('modules.purchases.description'),
    icon: FaShoppingBasket,
    color: '#fd7e14',
    menuItems: [
      { path: '/purchases-module/orders', icon: FaFileContract, label: t('nav.purchaseOrders') },
      { path: '/purchases-module/reception', icon: FaTruckLoading, label: t('nav.reception') },
      { path: '/purchases-module/invoices', icon: FaFileInvoice, label: t('nav.invoice') },
      { path: '/purchases-module/returns', icon: FaUndoAlt, label: t('nav.purchaseReturns') },
      {
        label: t('nav.suppliers'),
        icon: FaUserCircle,
        subMenu: [
          { path: '/purchases-module/fournisseurs', icon: FaFileInvoice, label: t('nav.suppliers') },
          { path: '/purchases-module/fournisseurs-etat', icon: FaList, label: t('nav.supplierEtat') }
        ]
      },
      {
        label: t('modules.finance.title'),
        icon: FaChartLine,
        subMenu: [
          { path: '/purchases-module/payments/fournisseur', icon: FaList, label: t('nav.listeReglementsFournisseur') },
          { path: '/purchases-module/supplier-deadlines', icon: FaMoneyCheck, label: t('nav.echeanceFournisseur') },
        ]
      },
      {
        label: t('nav.expenses'),
        icon: FaShoppingBasket,
        subMenu: [
          { path: '/purchases-module/expenses', icon: FaUserCheck, label: t('nav.expenses') },
          { path: '/purchases-module/expenses/categories', icon: FaUserCheck, label: t('nav.expensesCategories') }
        ]
      },
      {
        label: t('modules.reports.title'),
        icon: FaChartLine,
        subMenu: [
          { path: '/purchases-module/achats', icon: FaChartLine, label: t('nav.purchasesReports') },
          { path: '/purchases-module/operation/fournisseurs', icon: FaUser, label: t('nav.supplierReports') },
          { path: '/purchases-module/grand-livre/fournisseurs', icon: FaBook, label: t('purchases.grandLivre', 'Grand livre') },
          { path: '/purchases-module/commerciaux', icon: FaUser, label: t('nav.commercialReports') },
        ]
      },

    ]
  };

  return (
    <ModuleLayout moduleConfig={moduleConfig}>
      <Routes>
        <Route path="/" element={<Navigate to="/purchases-module/orders" replace />} />
        <Route path="/orders" element={<PurchasePage />} />
        <Route path="/orders/new" element={<BuyForm />} />
        <Route path="/orders/history" element={<BuysReport />} />
        <Route path="/reception" element={<ReceptionPage />} />
        <Route path="/invoices" element={<SupplierInvoiceList />} />
        <Route path="/invoices/new" element={<InvoiceForm />} />
        <Route path="/payments/fournisseur" element={<ReglementsFournisseurList />} />
        <Route path="/payments/fournisseur/new" element={<ReglementFournisseurForm />} />
        <Route path="/payments/fournisseur/edit" element={<ReglementFournisseurForm />} />
        <Route path="/supplier-deadlines" element={<FournisseurEcheance />} />
        <Route path="/returns" element={<FournisseurRetourList />} />
        <Route path="/returns/new" element={<FournisseurRetourForm />} />
        <Route path="/returns/edit" element={<FournisseurRetourForm />} />
        <Route path="/fournisseurs" element={<FournisseurList />} />
        <Route path="/fournisseurs-etat" element={<EtatFournisseur />} />
        <Route path="/fournisseurs/new" element={<FournisseurForm />} />
        <Route path="/fournisseurs/:id/edit" element={<FournisseurForm />} />
        {/* Expense routes can be added here */}
        <Route path="/expenses" element={<ExpenseList />} />
        <Route path="/expenses/new" element={<ExpenseForm />} />
        <Route path="/expenses/:id/edit" element={<ExpenseForm />} />
        <Route path="/expenses/categories" element={<ExpenseCategorieList />} />
        <Route path="/achats" element={<AchatsStatistiques />} />
        <Route path="/operation/fournisseurs" element={<MouvementSoldeFournisseur />} />
        <Route path="/grand-livre/fournisseurs" element={<GrandLivreFournisseurPage />} />
        <Route path="/commerciaux" element={<MouvementSoldeCommercial />} />

      </Routes>
    </ModuleLayout>
  );
};

export default PurchasesModule;
